import React from 'react';
import { AppContentPageTemplate } from './AppContentPageTemplate';
import { AppPageProps } from './AppPageProps';
import { DocsPageTemplate } from './DocsPageTemplate';
import { Head } from './Head';
import { PlainPageTemplate } from './PlainPageTemplate';

/**
 * Default template (aka Gatsby Layout) for our pages.
 * Its job is to load a more specific layout based on the path.
 *
 * Note this can be overridden if a page explicitly default exports a template.
 */
export default function DefaultPageTemplate(props: AppPageProps) {
  return (
    <>
      <Head pageProps={props} />
      <PageTemplateSwitch {...props} />
    </>
  );
}

function PageTemplateSwitch(props: AppPageProps) {
  const title = props.pageContext.frontmatter?.title;
  if (!title) {
    return <PlainPageTemplate {...props} />;
  } else if (props.location.pathname.startsWith('/learn')) {
    return <DocsPageTemplate {...props} />;
  } else if (props.location.pathname.startsWith('/app-content')) {
    return (
      <AppContentPageTemplate
        {...props}
        withoutApiToken={props.location.pathname.startsWith('/app-content/app-host-ready')}
      />
    );
  } else {
    return <PlainPageTemplate {...props} />;
  }
}
